import React from 'react';

export default class VerticalCenter extends React.Component {
    render() {
        return <div className={['VerticalCenter', this.props.className].join(' ')}>{this.props.children}</div>;
    }
}
